@use '../../../../app/styles/common/mixins';

.anchor {
  width: 100%;
  height: 0;
}

.root {
  background-color: var(--surface-00);
  display: flex;
  flex-direction: column;
  padding: 0;

  @include mixins.laptop {
    padding: 0 var(--spasing16);
    background-color: var(--surface-01);
  }

  @include mixins.desktop {
    padding: var(--spasing20) var(--spasing16) 0;
  }
}

// The actions bar's bottom padding is the 12px above the crumbs; this padding is the 12px below
.mobileBreadcrumbs {
  background-color: var(--surface-01);
  padding: 0 var(--spasing16) var(--spasing12);
}

.alert {
  @include mixins.heading-secondary-200;
  width: 100%;
  margin-bottom: var(--spasing16);
  padding: var(--spasing12);
  justify-content: center;
  color: var(--fg-primary) !important;
  border: 1px solid var(--border-warning-light);

  @include mixins.laptop {
    @include mixins.heading-secondary-100;
    height: 50px;
    margin: var(--spasing20) 0;
    line-height: 24px;
  }

  @include mixins.desktop {
    margin-top: 0;
  }
}

.headerRow {
  display: flex;
  flex-direction: column;
  gap: var(--spasing16);
  margin: 0;
  padding: 0;

  @include mixins.laptop {
    flex-direction: row;
  }
}

.headerCol {
  display: flex;
  padding: 0;
  width: 100%;
}

.headerStack {
  display: flex;
  flex-direction: column;
  gap: var(--spasing04);
  margin-bottom: var(--spasing04);

  @include mixins.laptop {
    flex-direction: row;
    align-items: stretch;
    gap: var(--spasing12);
    margin-bottom: 10px;
  }
}

.toggleWrapper {
  display: none;

  @include mixins.laptop {
    display: flex;
    justify-content: flex-start;
  }
}

.toggleButton {
  @include mixins.caption-primary-450;

  padding: 0;
  height: auto;
  gap: var(--spasing04);

  @include mixins.laptop {
    font-size: 18px;
    line-height: 22px;
  }
}

.toggleIcon {
  transition: transform 0.2s ease;
}

.toggleButtonOpen .toggleIcon {
  transform: rotate(180deg);
}

.section {
  padding: var(--spasing16);
  border-radius: var(--rounding16);
  background-color: var(--surface-01);

  @include mixins.laptop {
    padding: 0;
  }
}

.expandedSections {
  display: flex;
  flex-direction: column;
  gap: var(--spasing04);
  color: var(--fg-secondary);

  @include mixins.laptop {
    gap: var(--spasing32);
    margin-top: var(--spasing32);
  }

  h2 {
    margin-bottom: var(--spasing16);
  }

  .offerFeatures {
    p,
    a {
      color: var(--fg-secondary);
    }
  }

  .offerDescription {
    color: var(--fg-secondary);

    button {
      @include mixins.heading-secondary-100;
    }
  }
}

.sectionTitle {
  @include mixins.heading-primary-400;

  @include mixins.laptop {
    @include mixins.heading-primary-500;
  }
}

.similar {
  @include mixins.laptop {
    margin-top: var(--spasing40);
  }

  // BP-8082: 8px between the «Похожее» title and the grid on mobile/tablet.
  // The 2-class selector deterministically beats Feed's own `.container` padding.
  .similarFeed {
    padding-top: var(--spasing08);

    @include mixins.laptop {
      padding-top: var(--spasing16); // Feed's default, desktop unchanged
    }
  }
}

// Banner sits below the "similar" feed. On mobile/tablet it gets the same white
// card treatment as the other sections (.section); centered on all breakpoints.
.bannerSection {
  display: flex;
  justify-content: center;
  margin-top: var(--spasing04);
  margin-bottom: var(--spasing04);

  @include mixins.laptop {
    margin-top: var(--spasing40);
  }
}
